<mat-form-field class="xp-password-field__form-field"
                appearance="outline"
                [subscriptSizing]="subscriptSizing()">
	<mat-label *ngIf="label()">{{ label() }}</mat-label>
	<input matInput
	       class="xp-password-field__input"
	       [attr.data-testid]="inputTestId() || null"
	       [type]="visible() ? 'text' : 'password'"
	       [ngModel]="value()"
	       (ngModelChange)="value.set($event)"
	       [placeholder]="placeholder()"
	       [disabled]="disabled()"
	       [errorStateMatcher]="errorStateMatcher"
	       (focus)="focused.emit()"
	       (blur)="blurred.emit()" />
	<button *ngIf="showToggle()"
	        mat-icon-button
	        matSuffix
	        type="button"
	        [attr.aria-label]="visible() ? hideLabel() : showLabel()"
	        (click)="toggleVisibility()">
		<mat-icon>{{ visible() ? hideIcon() : showIcon() }}</mat-icon>
	</button>
	<mat-icon *ngIf="suffixIcon()" matSuffix class="xp-password-field__suffix-icon">{{ suffixIcon() }}</mat-icon>
	<mat-error *ngIf="showError() && errorText()">{{ errorText() }}</mat-error>
</mat-form-field>
